const gameWeekDates = [
    new Date('2016-08-17'),
    new Date('2016-08-24'),
    new Date('2016-08-31'),
    new Date('2016-09-07'),
    new Date('2016-09-14')
];

export default gameWeekDates;


/** WEBPACK FOOTER **
 ** ./src/data/gameWeekDates.js
 **/